import {LocalisableEntityData} from "@fedeltapointofsale/data-client";

export class StockTakeData extends LocalisableEntityData<StockTakeData> {
    stockTakeId;
}
